<div *kienePermission="[1001]" class="kiene-content-page">
    <div class="kiene-table-header">
        <div>
            <button
                (click)="goBack()"
                mat-icon-button
                matTooltip="zurück"
                style="display: inline-block"
                [attr.data-cy]="'mmdmd_button_1_0_'"
            >
                <mat-icon color="primary" [attr.data-cy]="'mmdmd_mat-icon_1_2_'">arrow_back</mat-icon>
            </button>
            <h2 style="display: inline-block; margin-left: 20px" [attr.data-cy]="'mmdmd_h2_1_'">
                Artikel {{ material.artikel_me }}
                <span *ngIf="urlId === 'neu'" [attr.data-cy]="'mmdmd_span_1_16_'">neu anlegen</span>
            </h2>
        </div>
    </div>
    <div>
        <div class="one-row">
            <div style="width: 100%">
                <div style="padding-bottom: 30px">
                    <mat-tab-group
                        (selectedTabChange)="setSelectedTab($event)"
                        [selectedIndex]="selectedTab"
                        [attr.data-cy]="'mmdmd_mat-tab_1_5_'"
                    >
                        <!--

              Tab Allgemein

            -->
                        <mat-tab label="Allgemein" [attr.data-cy]="'mmdmd_mat-tab_2_5_'">
                            <ng-template matTabContent>
                            <mat-card
                                style="margin-bottom: 20px; margin-top: 20px"
                                [attr.data-cy]="'mmdmd_mat-card_1_11_'"
                            >
                                <h5>Allgemein</h5>

                                <div class="one-row">
                                    <mat-form-field
                                        style="min-width: 400px; margin-right: 1%"
                                        [attr.data-cy]="'mmdmd_mat-form-field_1_8_'"
                                    >
                                        <mat-label [attr.data-cy]="'mmdmd_mat-label_1_9_'">Bezeichnung</mat-label>
                                        <span matPrefix [attr.data-cy]="'mmdmd_span_2_16_'">
                                            <mat-icon [attr.data-cy]="'mmdmd_mat-icon_2_2_'">description</mat-icon
                                            >&nbsp;&nbsp;
                                        </span>
                                        <input
                                            [formControl]="bezeichnungCtrl"
                                            matInput
                                            required
                                            type="text"
                                            [attr.data-cy]="'mmdmd_input_1_1_'"
                                        />
                                    </mat-form-field>

                                    <kiene-autocomplete
                                        *ngIf="hasPermission(4451)"
                                        #wirkstoffAutocomplete
                                        (deleteSelected)="deleteWirkstoff($event)"
                                        (elementSelected)="setWirkstoff($event)"
                                        [apiUrl]="'wirkstoff/'"
                                        [displayField]="'wirkstoff'"
                                        [emitFreeText]="true"
                                        [focus]="false"
                                        [kieneObject]="material?.wirkstoff"
                                        [placeholder]="'Wirkstoff'"
                                        [readPermission]="[4451]"
                                        [showDeleteButton]="true"
                                        [attr.data-cy]="'mmdmd_mat-autocomplete_0_1_'"
                                    ></kiene-autocomplete>

                                    <mat-form-field
                                        *ngIf="!hasPermission(4451)"
                                        style="min-width: 200px; margin-right: 1%"
                                        [attr.data-cy]="'mmdmd_mat-form-field_wirkstoff_ro'"
                                    >
                                        <mat-label>Wirkstoff</mat-label>
                                        <input
                                            [formControl]="wirkstoffCtrl"
                                            matInput
                                            type="text"
                                            [attr.data-cy]="'mmdmd_input_wirkstoff_'"
                                        />
                                    </mat-form-field>

                                    <span class="spacer" [attr.data-cy]="'mmdmd_span_3_16_'"></span>
                                </div>

                                <br />

                                <mat-form-field
                                    style="min-width: 100px; margin-right: 1%"
                                    [attr.data-cy]="'mmdmd_mat-form-field_2_8_'"
                                >
                                    <mat-label [attr.data-cy]="'mmdmd_mat-label_2_9_'">Kürzel</mat-label>
                                    <span matPrefix [attr.data-cy]="'mmdmd_span_4_16_'">
                                        <mat-icon [attr.data-cy]="'mmdmd_mat-icon_3_2_'">short_text</mat-icon
                                        >&nbsp;&nbsp;
                                    </span>
                                    <input
                                        [formControl]="kuerzelCtrl"
                                        matInput
                                        placeholder="K&uuml;rzel"
                                        type="text"
                                        [attr.data-cy]="'mmdmd_input_2_1_'"
                                    />
                                </mat-form-field>

                                <mat-form-field
                                    style="min-width: 100px; margin-right: 1%"
                                    [attr.data-cy]="'mmdmd_mat-form-field_3_8_'"
                                >
                                    <mat-label [attr.data-cy]="'mmdmd_mat-label_3_9_'">EAN</mat-label>
                                    <span matPrefix [attr.data-cy]="'mmdmd_span_5_16_'">
                                        <mat-icon [attr.data-cy]="'mmdmd_mat-icon_4_2_'">star</mat-icon>&nbsp;&nbsp;
                                    </span>
                                    <input
                                        [formControl]="eanCtrl"
                                        matInput
                                        placeholder="EAN"
                                        type="text"
                                        [attr.data-cy]="'mmdmd_input_3_1_'"
                                    />
                                </mat-form-field>

                                <mat-form-field
                                    style="min-width: 100px; margin-right: 1%"
                                    [attr.data-cy]="'mmdmd_mat-form-field_4_8_'"
                                >
                                    <mat-label [attr.data-cy]="'mmdmd_mat-label_4_9_'"
                                        >Alt. Produktkennzeichnungen
                                    </mat-label>
                                    <span matPrefix [attr.data-cy]="'mmdmd_span_6_16_'">
                                        <mat-icon [attr.data-cy]="'mmdmd_mat-icon_5_2_'">tag</mat-icon>&nbsp;&nbsp;
                                    </span>
                                    <input
                                        [formControl]="produktkennzeichnungCtrl"
                                        matInput
                                        placeholder="Alt. Produktkennzeichnung"
                                        type="text"
                                        [attr.data-cy]="'mmdmd_input_4_1_'"
                                    />
                                </mat-form-field>

                                <mat-form-field
                                    style="min-width: 100px; margin-right: 1%"
                                    [attr.data-cy]="'mmdmd_mat-form-field_5_8_'"
                                >
                                    <mat-label [attr.data-cy]="'mmdmd_mat-label_5_9_'">Interne Artikelnr.</mat-label>
                                    <span matPrefix [attr.data-cy]="'mmdmd_span_7_16_'">
                                        <mat-icon [attr.data-cy]="'mmdmd_mat-icon_6_2_'">star</mat-icon>&nbsp;&nbsp;
                                    </span>
                                    <input
                                        [formControl]="interneNrCtrl"
                                        matInput
                                        placeholder="Interne Artikelnummer"
                                        type="text"
                                        [attr.data-cy]="'mmdmd_input_5_1_'"
                                    />
                                </mat-form-field>
                                <br />

                                <mat-form-field
                                    *ngIf="hasPermission(1791)"
                                    style="min-width: 100px; margin-right: 1%"
                                    [attr.data-cy]="'mmdmd_mat-form-field_6_8_'"
                                >
                                    <mat-label [attr.data-cy]="'mmdmd_mat-label_6_9_'">Einheit</mat-label>
                                    <span matPrefix [attr.data-cy]="'mmdmd_span_8_16_'">
                                        <mat-icon [attr.data-cy]="'mmdmd_mat-icon_7_2_'">info</mat-icon>&nbsp;&nbsp;
                                    </span>
                                    <mat-select
                                        [compareWith]="einheitComparator"
                                        [formControl]="einheitCtrl"
                                        [attr.data-cy]="'mmdmd_mat-select_7_2_'"
                                    >
                                        <mat-option
                                            *ngFor="let u of units; let i = index"
                                            [value]="u.einheit_id"
                                            [attr.data-cy]="'mmdmd_mat-option_7_2_' + i"
                                            >{{ u.bezeichnung }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <mat-form-field
                                    *ngIf="!hasPermission(1791)"
                                    style="min-width: 100px; margin-right: 1%"
                                    [attr.data-cy]="'mmdmd_mat-form-field_6_8_ro'"
                                >
                                    <mat-label>Einheit</mat-label>
                                    <input matInput [value]="material?.einheit || ''" readonly disabled />
                                </mat-form-field>

                                <mat-form-field
                                    style="min-width: 100px; margin-right: 1%"
                                    [attr.data-cy]="'mmdmd_mat-form-field_7_8_'"
                                >
                                    <mat-label [attr.data-cy]="'mmdmd_mat-label_7_9_'">Volumen</mat-label>
                                    <span matPrefix [attr.data-cy]="'mmdmd_span_9_16_'">
                                        <mat-icon [attr.data-cy]="'mmdmd_mat-icon_8_2_'">opacity</mat-icon>&nbsp;&nbsp;
                                    </span>
                                    <input
                                        [formControl]="mengeCtrl"
                                        matInput
                                        placeholder="Volumen"
                                        type="text"
                                        [attr.data-cy]="'mmdmd_input_6_1_'"
                                    />
                                </mat-form-field>

                                <mat-form-field
                                    style="min-width: 100px; margin-right: 1%"
                                    [attr.data-cy]="'mmdmd_mat-form-field_8_8_'"
                                >
                                    <mat-label [attr.data-cy]="'mmdmd_mat-label_8_9_'">Lagereinheit</mat-label>
                                    <span matPrefix [attr.data-cy]="'mmdmd_span_10_16_'">
                                        <mat-icon [attr.data-cy]="'mmdmd_mat-icon_9_2_'">info</mat-icon>&nbsp;&nbsp;
                                    </span>
                                    <input
                                        [formControl]="lagereinheitCtrl"
                                        matInput
                                        placeholder="Lagereinheit"
                                        type="text"
                                        [attr.data-cy]="'mmdmd_input_7_1_'"
                                    />
                                </mat-form-field>

                                <mat-form-field
                                    style="min-width: 100px; margin-right: 1%"
                                    [attr.data-cy]="'mmdmd_mat-form-field_9_8_'"
                                >
                                    <mat-label [attr.data-cy]="'mmdmd_mat-label_9_9_'">Faktor</mat-label>
                                    <span matPrefix [attr.data-cy]="'mmdmd_span_11_16_'">
                                        <mat-icon [attr.data-cy]="'mmdmd_mat-icon_10_2_'">calculate</mat-icon
                                        >&nbsp;&nbsp;
                                    </span>
                                    <input
                                        [formControl]="faktorCtrl"
                                        matInput
                                        type="number"
                                        [attr.data-cy]="'mmdmd_input_8_1_'"
                                    />
                                </mat-form-field>

                                <br />

                                <mat-form-field
                                    style="min-width: 100px; margin-right: 1%"
                                    [attr.data-cy]="'mmdmd_mat-form-field_10_8_'"
                                >
                                    <mat-label [attr.data-cy]="'mmdmd_mat-label_10_9_'">Umrechnungsfaktor</mat-label>
                                    <span matPrefix [attr.data-cy]="'mmdmd_span_12_16_'">
                                        <mat-icon [attr.data-cy]="'mmdmd_mat-icon_11_2_'">swap_horiz</mat-icon
                                        >&nbsp;&nbsp;
                                    </span>
                                    <input
                                        [formControl]="umrechnungFaktCtrl"
                                        matInput
                                        placeholder="Umrechnungsfaktor"
                                        type="number"
                                        [attr.data-cy]="'mmdmd_input_9_1_'"
                                    />
                                </mat-form-field>

                                <mat-form-field
                                    style="min-width: 100px; width: 228px; margin-right: 1%"
                                    [attr.data-cy]="'mmdmd_mat-form-field_11_8_'"
                                >
                                    <mat-label [attr.data-cy]="'mmdmd_mat-label_11_9_'"
                                        >Gebindegr&ouml;&szlig;e
                                    </mat-label>
                                    <span matPrefix style="padding-right: 5px" [attr.data-cy]="'mmdmd_span_13_16_'">
                                        <mat-icon [attr.data-cy]="'mmdmd_mat-icon_12_2_'">storage</mat-icon
                                        >&nbsp;&nbsp;&nbsp;
                                    </span>
                                    <input
                                        [formControl]="gebindegroesseCtrl"
                                        matInput
                                        type="number"
                                        [attr.data-cy]="'mmdmd_input_10_1_'"
                                    />
                                    <span matSuffix [attr.data-cy]="'mmdmd_span_14_16_'">Stk.</span>
                                </mat-form-field>

                                <mat-form-field
                                    style="min-width: 100px; margin-right: 1%"
                                    [attr.data-cy]="'mmdmd_mat-form-field_12_8_'"
                                >
                                    <mat-label [attr.data-cy]="'mmdmd_mat-label_12_9_'">Ermittlung Rohertrag</mat-label>
                                    <mat-select
                                        [formControl]="ermittlungRohertragCtrl"
                                        placeholder="Ermittlung Rohertrag"
                                        [attr.data-cy]="'mmdmd_mat-select_11_1_'"
                                    >
                                        <mat-option
                                            value="Durchschnittlicher EK"
                                            [attr.data-cy]="'mmdmd_mat-option_11_1_1_'"
                                            >Durchschnittlicher EK
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <br />

                                <mat-form-field
                                    *ngIf="hasPermission(2571)"
                                    style="min-width: 350px; margin-right: 1%"
                                    [attr.data-cy]="'mmdmd_mat-form-field_13_8_'"
                                >
                                    <mat-label [attr.data-cy]="'mmdmd_mat-label_13_9_'">Warengruppe</mat-label>
                                    <span matPrefix [attr.data-cy]="'mmdmd_span_15_16_'">
                                        <mat-icon [attr.data-cy]="'mmdmd_mat-icon_13_2_'">folder</mat-icon>&nbsp;&nbsp;
                                    </span>
                                    <mat-select
                                        [compareWith]="warengruppeComparator"
                                        [formControl]="warengruppeCtrl"
                                        placeholder="Warengruppe"
                                        [attr.data-cy]="'mmdmd_mat-select_13_2_'"
                                    >
                                        <mat-option
                                            *ngFor="let w of warengruppen; let i = index"
                                            [value]="w"
                                            [attr.data-cy]="'mmdmd_mat-option_13_2_' + i"
                                            >{{ w.bezeichnung }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <mat-form-field
                                    *ngIf="!hasPermission(2571)"
                                    style="min-width: 350px; margin-right: 1%"
                                    [attr.data-cy]="'mmdmd_mat-form-field_13_8_ro'"
                                >
                                    <mat-label>Warengruppe</mat-label>
                                    <input matInput [value]="material?.warengruppe || ''" readonly disabled />
                                </mat-form-field>
                                <br />

                                <mat-slide-toggle
                                    [formControl]="gotCtrl"
                                    class="phito-toggle"
                                    color="primary"
                                    [attr.data-cy]="'mmdmd_mat-toggle_0_0_'"
                                >
                                    GOT-Artikel
                                </mat-slide-toggle>
                                <br />

                                <mat-slide-toggle
                                    [formControl]="gesperrtCtrl"
                                    class="phito-toggle"
                                    color="primary"
                                    [attr.data-cy]="'mmdmd_mat-toggle_1_0_'"
                                >
                                    Artikel gesperrt
                                </mat-slide-toggle>
                                <br />

                                <div style="text-align: right">
                                    <button
                                        (click)="updateAllgemein()"
                                        *kienePermission="[1003]"
                                        [disabled]="bezeichnungCtrl.invalid"
                                        color="accent"
                                        mat-flat-button
                                        type="button"
                                        [attr.data-cy]="'mmdmd_button_2_0_'"
                                    >
                                        Allgemein Speichern
                                    </button>
                                </div>
                            </mat-card>

                            <mat-card
                                *ngIf="!isCreationForm"
                                style="margin-bottom: 20px"
                                [attr.data-cy]="'mmdmd_mat-card_2_11_'"
                            >
                                <h5>Lagerbestand</h5>

                                <mat-form-field
                                    style="min-width: 100px; margin-right: 1%"
                                    [attr.data-cy]="'mmdmd_mat-form-field_14_8_'"
                                >
                                    <mat-label [attr.data-cy]="'mmdmd_mat-label_14_9_'">Mindestbestand</mat-label>
                                    <span matPrefix [attr.data-cy]="'mmdmd_span_16_16_'">
                                        <mat-icon [attr.data-cy]="'mmdmd_mat-icon_14_2_'">store</mat-icon>&nbsp;&nbsp;
                                    </span>
                                    <input
                                        [formControl]="mindestbestandCtrl"
                                        matInput
                                        placeholder="Mindestbestand"
                                        type="number"
                                        [attr.data-cy]="'mmdmd_input_11_1_'"
                                    />
                                    <span matSuffix [attr.data-cy]="'mmdmd_span_17_16_'"> Stk. </span>
                                </mat-form-field>

                                <mat-form-field
                                    style="min-width: 100px; margin-right: 1%"
                                    [attr.data-cy]="'mmdmd_mat-form-field_15_8_'"
                                >
                                    <mat-label [attr.data-cy]="'mmdmd_mat-label_15_9_'">Bestellmenge</mat-label>
                                    <span matPrefix [attr.data-cy]="'mmdmd_span_18_16_'">
                                        <mat-icon [attr.data-cy]="'mmdmd_mat-icon_15_2_'">functions</mat-icon
                                        >&nbsp;&nbsp;
                                    </span>
                                    <input
                                        [formControl]="bestellmengeCtrl"
                                        matInput
                                        placeholder="Bestellmenge"
                                        type="number"
                                        [attr.data-cy]="'mmdmd_input_12_1_'"
                                    />
                                    <span matSuffix [attr.data-cy]="'mmdmd_span_19_16_'"> Stk. </span>
                                </mat-form-field>

                                <mat-form-field
                                    style="min-width: 100px; margin-right: 1%"
                                    [attr.data-cy]="'mmdmd_mat-form-field_16_8_'"
                                >
                                    <mat-label [attr.data-cy]="'mmdmd_mat-label_16_9_'">Sicherheitsbestand</mat-label>
                                    <input
                                        [formControl]="secureStockCtrl"
                                        matInput
                                        placeholder="Sicherheitsbestand"
                                        type="number"
                                        [attr.data-cy]="'mmdmd_input_13_1_'"
                                    />
                                    <span matSuffix [attr.data-cy]="'mmdmd_span_20_16_'">Stk.</span>
                                </mat-form-field>

                                <mat-slide-toggle
                                    [attr.data-cy]="'mmdmd_toggle_1_'"
                                    [formControl]="variableSecureStockCtrl"
                                    class="phito-toggle"
                                    color="primary"
                                    style="min-width: 350px; margin-right: 1%"
                                    >Variabler Sicherheitsbestand
                                </mat-slide-toggle>

                                <mat-form-field style="min-width: 100px" [attr.data-cy]="'mmdmd_mat-form-field_17_8_'">
                                    <mat-label [attr.data-cy]="'mmdmd_mat-label_17_9_'">Konst. Bestellmenge</mat-label>
                                    <span matPrefix [attr.data-cy]="'mmdmd_span_21_16_'">&Sigma;&nbsp;&nbsp;</span>
                                    <input
                                        [formControl]="bestellmengeKonstantCtrl"
                                        matInput
                                        placeholder="Konst. Bestellmenge"
                                        type="number"
                                        [attr.data-cy]="'mmdmd_input_14_1_'"
                                    />
                                </mat-form-field>

                                <div style="text-align: right">
                                    <button
                                        (click)="updateLager()"
                                        *kienePermission="[1003]"
                                        [disabled]="bezeichnungCtrl.invalid"
                                        color="accent"
                                        mat-flat-button
                                        type="button"
                                        [attr.data-cy]="'mmdmd_button_3_0_'"
                                    >
                                        Lager Speichern
                                    </button>
                                </div>
                            </mat-card>
                            </ng-template>
                        </mat-tab>
                        <!--

              Tab Preise

            -->
                        <mat-tab
                            *ngIf="hasAtLeastOnePermissionForPrices()"
                            aria-label="Preise"
                            label="Preise"
                            [attr.data-cy]="'mmdmd_mat-tab_3_5_'"
                        >
                            <ng-template matTabContent>
                            <div>
                                <mat-card
                                    *kienePermission="[3211]"
                                    style="margin-bottom: 20px; margin-top: 20px"
                                    [attr.data-cy]="'mmdmd_mat-card_3_11_'"
                                >
                                    <h5>Finanzen</h5>
                                    <mat-form-field [attr.data-cy]="'mmdmd_mat-field_1_6_'">
                                        <mat-select
                                            [formControl]="vatCtrl"
                                            placeholder="USt. in %"
                                            [attr.data-cy]="'mmdmd_mat-select_3_6_'"
                                        >
                                            <mat-option
                                                *ngFor="let ust of ustValues; let i = index"
                                                [value]="ust"
                                                [attr.data-cy]="'mmdmd_mat-option_' + i"
                                            >
                                                {{ ust }} %
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <h5>Buchungskonten FiBu</h5>
                                    <mat-form-field
                                        style="margin-right: 12px"
                                        [attr.data-cy]="'mmdmd_mat-form-field_18_8_'"
                                    >
                                        <mat-label [attr.data-cy]="'mmdmd_mat-label_18_9_'">Buchungskonto</mat-label>
                                        <input
                                            [formControl]="buchungskontoCtrl"
                                            matInput
                                            type="text"
                                            [attr.data-cy]="'mmdmd_input_15_1_'"
                                        />
                                    </mat-form-field>
                                    <mat-form-field [attr.data-cy]="'mmdmd_mat-form-field_19_8_'">
                                        <mat-label [attr.data-cy]="'mmdmd_mat-label_19_9_'"
                                            >Buchungsgegenkonto
                                        </mat-label>
                                        <input
                                            [formControl]="buchungsgegenkontoCtrl"
                                            matInput
                                            type="text"
                                            [attr.data-cy]="'mmdmd_input_16_1_'"
                                        />
                                    </mat-form-field>
                                    <mat-card-actions
                                        style="text-align: right"
                                        [attr.data-cy]="'mmdmd_mat-card-actions_1_14_'"
                                    >
                                        <button
                                            (click)="saveFinanzen()"
                                            [disabled]="
                                                material.artikel_id === null || material.artikel_id === undefined
                                            "
                                            color="accent"
                                            mat-flat-button
                                            [attr.data-cy]="'mmdmd_button_4_0_'"
                                        >
                                            Finanzen Speichern
                                        </button>
                                    </mat-card-actions>
                                </mat-card>

                                <ng-container *kienePermission="[1091]">
                                    <kiene-supplier-material
                                        (currentStandardSupplierMaterial)="setCurrentStandardSupplierMaterial($event)"
                                        *ngIf="material.stueckliste !== 1"
                                        [disabled]="KieneUtils.isApiOne(material.stueckliste)"
                                        [material]="material"
                                    >
                                    </kiene-supplier-material>
                                </ng-container>

                                <ng-container *kienePermission="[1099]">
                                    <mat-card
                                        *ngIf="KieneUtils.isApiOne(material.stueckliste)"
                                        style="margin-bottom: 20px"
                                        [attr.data-cy]="'mmdmd_mat-card_4_11_'"
                                    >
                                        <h5>Einkaufspreis</h5>
                                        <p>
                                            Der Einkaufspreis wird in der St&uuml;ckliste definiert und entspricht:
                                            {{ stuecklistenEinkaufspreis | number: "1.2-2" }}
                                            &euro;
                                        </p>
                                    </mat-card>
                                </ng-container>

                                <kiene-material-sales-prices
                                    *ngIf="hasPermission(3201)"
                                    [ek]="purchasePrice"
                                    [material]="material"
                                    [rabatt]="discount"
                                    [vat]="vatCtrl.value"
                                ></kiene-material-sales-prices>

                                <kiene-rabatt-staffel
                                    *kienePermission="[3411]"
                                    [material]="material"
                                ></kiene-rabatt-staffel>
                            </div>
                            </ng-template>
                        </mat-tab>
                        <!--

              Tab Einstellungen

            -->
                        <mat-tab
                            *ngIf="hasPermissionForEinstellungenTab()"
                            label="Einstellungen"
                            [attr.data-cy]="'mmdmd_mat-tab_4_5_'"
                        >
                            <ng-template matTabContent>
                            <mat-card
                                style="margin-bottom: 20px; margin-top: 20px"
                                [attr.data-cy]="'mmdmd_mat-card_5_11_'"
                            >
                                <div class="one-row">
                                    <div>
                                        <h5>Artikeleinstellungen</h5>
                                        <mat-slide-toggle
                                            [formControl]="behandlungsartikelCtrl"
                                            class="phito-toggle"
                                            color="primary"
                                            (change)="updateEinstellungen()"
                                            [disabled]="isLoadingOrSaving"
                                            [attr.data-cy]="'mmdmd_mat-slide-toggle_1_5_'"
                                        >
                                            Behandlungsartikel
                                        </mat-slide-toggle>
                                        <br />
                                        <mat-slide-toggle
                                            [formControl]="abgabeCtrl"
                                            class="phito-toggle"
                                            color="primary"
                                            (change)="updateEinstellungen()"
                                            [disabled]="isLoadingOrSaving"
                                            [attr.data-cy]="'mmdmd_mat-slide-toggle_2_5_'"
                                        >
                                            Abgabeartikel
                                        </mat-slide-toggle>
                                        <br />
                                        <div class="one-row">
                                            <mat-slide-toggle
                                                [formControl]="laborartikelCtrl"
                                                class="phito-toggle"
                                                color="primary"
                                                (change)="updateEinstellungen()"
                                                [disabled]="isLoadingOrSaving"
                                                [attr.data-cy]="'mmdmd_mat-slide-toggle_3_5_'"
                                            >
                                                Laborartikel
                                            </mat-slide-toggle>
                                            <span class="spacer" [attr.data-cy]="'mmdmd_span_22_16_'"></span>
                                        </div>
                                        <br />
                                        <mat-slide-toggle
                                            [formControl]="mengenartikelCtrl"
                                            class="phito-toggle"
                                            color="primary"
                                            (change)="updateEinstellungen()"
                                            [disabled]="isLoadingOrSaving"
                                            [attr.data-cy]="'mmdmd_mat-slide-toggle_4_5_'"
                                        >
                                            Mengenartikel
                                        </mat-slide-toggle>
                                        <br />
                                        <mat-slide-toggle
                                            [formControl]="chargeJaNeinCtrl"
                                            class="phito-toggle"
                                            color="primary"
                                            (change)="updateEinstellungen()"
                                            [disabled]="isLoadingOrSaving"
                                            [attr.data-cy]="'mmdmd_mat-slide-toggle_5_5_'"
                                        >
                                            Charge J/N
                                        </mat-slide-toggle>
                                        <br />
                                        <mat-slide-toggle
                                            [formControl]="sonstigeAbgabeCtrl"
                                            class="phito-toggle"
                                            color="primary"
                                            (change)="updateEinstellungen()"
                                            [disabled]="isLoadingOrSaving"
                                            [attr.data-cy]="'mmdmd_mat-slide-toggle_6_5_'"
                                        >
                                            sonstige Abgabe
                                        </mat-slide-toggle>
                                        <br />
                                        <mat-slide-toggle
                                            [formControl]="betaeubungsmittelCtrl"
                                            class="phito-toggle"
                                            color="primary"
                                            (change)="updateEinstellungen()"
                                            [disabled]="isLoadingOrSaving"
                                            [attr.data-cy]="'mmdmd_mat-slide-toggle_7_5_'"
                                        >
                                            Betäubungsmittel
                                        </mat-slide-toggle>
                                        <br />
                                        <!--
                  <mat-slide-toggle class="phito-toggle" color="primary" [formControl]="hitCtrl" [attr.data-cy]="'mmdmd_mat-slide-toggle_8_5_'">Meldung an HIT
                  </mat-slide-toggle><br>-->
                                        <mat-slide-toggle
                                            [formControl]="antibiotikumCtrl"
                                            class="phito-toggle"
                                            color="primary"
                                            (change)="updateEinstellungen()"
                                            [disabled]="isLoadingOrSaving"
                                            [attr.data-cy]="'mmdmd_mat-slide-toggle_9_5_'"
                                            >Antibiotikum
                                        </mat-slide-toggle>
                                        <br />
                                        <mat-slide-toggle
                                            [formControl]="impstoffCtrl"
                                            class="phito-toggle"
                                            color="primary"
                                            (change)="updateEinstellungen()"
                                            [disabled]="isLoadingOrSaving"
                                            [attr.data-cy]="'mmdmd_mat-slide-toggle_10_5_'"
                                            >Impfstoff
                                        </mat-slide-toggle>
                                        <br />
                                        <mat-slide-toggle
                                            [formControl]="nichtAbgebbarCtrl"
                                            class="phito-toggle"
                                            color="primary"
                                            (change)="updateEinstellungen()"
                                            [disabled]="isLoadingOrSaving"
                                            [attr.data-cy]="'mmdmd_mat-slide-toggle_11_5_'"
                                            >nicht abgebbar
                                        </mat-slide-toggle>
                                        <br />
                                        <mat-slide-toggle
                                            [formControl]="bestellvorschlagCtrl"
                                            class="phito-toggle"
                                            color="primary"
                                            (change)="updateEinstellungen()"
                                            [disabled]="isLoadingOrSaving"
                                            [attr.data-cy]="'mmdmd_mat-slide-toggle_12_5_'"
                                            >In Bestellvorschlägen anzeigen
                                        </mat-slide-toggle>
                                        <br />
                                        <mat-slide-toggle
                                            [formControl]="stuecklisteCtrl"
                                            class="phito-toggle"
                                            color="primary"
                                            (change)="updateEinstellungen()"
                                            [disabled]="isLoadingOrSaving"
                                            [attr.data-cy]="'mmdmd_mat-slide-toggle_13_5_'"
                                            >Ist St&uuml;ckliste
                                        </mat-slide-toggle>
                                        <br />
                                        <div class="one-row">
                                            <mat-slide-toggle
                                                [formControl]="provisionsfaehigCtrl"
                                                class="phito-toggle"
                                                color="primary"
                                                [disabled]="isLoadingOrSaving"
                                                (change)="updateEinstellungen()"
                                                [attr.data-cy]="'mmdmd_mat-slide-toggle_14_5_'"
                                            >
                                                Provisionsfähig
                                            </mat-slide-toggle>
                                            <mat-form-field
                                                style="margin-left: 12px"
                                                [attr.data-cy]="'mmdmd_mat-form-field_20_8_'"
                                            >
                                                <mat-label [attr.data-cy]="'mmdmd_mat-label_20_9_'"
                                                    >Provision in &euro;
                                                </mat-label>
                                                <input
                                                    [formControl]="provisionCtrl"
                                                    matInput
                                                    type="number"
                                                    (change)="updateEinstellungen()"
                                                    [disabled]="isLoadingOrSaving"
                                                    [attr.data-cy]="'mmdmd_input_17_1_'"
                                                />
                                            </mat-form-field>
                                            <span class="spacer" [attr.data-cy]="'mmdmd_span_23_16_'"></span>
                                        </div>
                                        <div class="one-row">
                                            <mat-slide-toggle
                                                [formControl]="tourenplanCtrl"
                                                class="phito-toggle"
                                                color="primary"
                                                (change)="updateEinstellungen()"
                                                [disabled]="isLoadingOrSaving"
                                                [attr.data-cy]="'mmdmd_mat-slide-toggle_15_5_'"
                                            >
                                                Neuen Tourenplan Eintrag erzeugen
                                            </mat-slide-toggle>
                                            <mat-form-field
                                                style="margin-left: 12px"
                                                [attr.data-cy]="'mmdmd_mat-form-field_21_8_'"
                                            >
                                                <mat-label [attr.data-cy]="'mmdmd_mat-label_21_9_'"
                                                    >in Tagen ab heute
                                                </mat-label>
                                                <input
                                                    [formControl]="tourenplanTageCtrl"
                                                    matInput
                                                    type="number"
                                                    (change)="updateEinstellungen()"
                                                    [disabled]="isLoadingOrSaving"
                                                    [attr.data-cy]="'mmdmd_input_18_1_'"
                                                />
                                            </mat-form-field>
                                            <span class="spacer" [attr.data-cy]="'mmdmd_span_24_16_'"></span>
                                        </div>
                                        <br />
                                        <mat-slide-toggle
                                            [formControl]="rabattfaehigCtrl"
                                            class="phito-toggle"
                                            color="primary"
                                            (change)="updateEinstellungen()"
                                            [disabled]="isLoadingOrSaving"
                                            [attr.data-cy]="'mmdmd_mat-slide-toggle_16_5_'"
                                        >
                                            Rabattfähig
                                        </mat-slide-toggle>
                                        <br />
                                        <mat-slide-toggle
                                            [formControl]="bonusfaehigCtrl"
                                            class="phito-toggle"
                                            color="primary"
                                            (change)="updateEinstellungen()"
                                            [disabled]="isLoadingOrSaving"
                                            [attr.data-cy]="'mmdmd_mat-slide-toggle_17_5_'"
                                            >Bonusfähig
                                        </mat-slide-toggle>
                                        <br />
                                        <mat-slide-toggle
                                            [formControl]="skontofaehigCtrl"
                                            class="phito-toggle"
                                            color="primary"
                                            (change)="updateEinstellungen()"
                                            [disabled]="isLoadingOrSaving"
                                            [attr.data-cy]="'mmdmd_mat-slide-toggle_18_5_'"
                                        >
                                            Skontofähig
                                        </mat-slide-toggle>
                                        <br />
                                        <mat-slide-toggle
                                            [formControl]="bestellwesenCtrl"
                                            class="phito-toggle"
                                            color="primary"
                                            (change)="updateEinstellungen()"
                                            [disabled]="isLoadingOrSaving"
                                            [attr.data-cy]="'mmdmd_mat-slide-toggle_19_5_'"
                                        >
                                            Bestellwesen
                                        </mat-slide-toggle>
                                        <br />
                                        <mat-slide-toggle
                                            [formControl]="keinNegativBestandCtrl"
                                            class="phito-toggle"
                                            color="primary"
                                            (change)="updateEinstellungen()"
                                            [disabled]="isLoadingOrSaving"
                                            [attr.data-cy]="'mmdmd_mat-slide-toggle_20_5_'"
                                            >Kein Negativbestand
                                        </mat-slide-toggle>
                                        <br />
                                        <mat-slide-toggle
                                            [formControl]="lagerbestaendeVerbuchenCtrl"
                                            class="phito-toggle"
                                            color="primary"
                                            (change)="updateEinstellungen()"
                                            [disabled]="isLoadingOrSaving"
                                            [attr.data-cy]="'mmdmd_mat-slide-toggle_21_5_'"
                                        >
                                            Lagerbestände verbuchen
                                        </mat-slide-toggle>
                                        <br />
                                        <mat-slide-toggle
                                            [formControl]="keinLiefervorschlagCtrl"
                                            class="phito-toggle"
                                            color="primary"
                                            (change)="updateEinstellungen()"
                                            [disabled]="isLoadingOrSaving"
                                            [attr.data-cy]="'mmdmd_mat-slide-toggle_22_5_'"
                                            >Kein Liefervorschlag
                                        </mat-slide-toggle>
                                        <br />
                                        <mat-slide-toggle
                                            [formControl]="keineBarcodeErfassungCtrl"
                                            class="phito-toggle"
                                            color="primary"
                                            (change)="updateEinstellungen()"
                                            [disabled]="isLoadingOrSaving"
                                            [attr.data-cy]="'mmdmd_mat-slide-toggle_23_5_'"
                                        >
                                            Keine Barcodeerfassung
                                        </mat-slide-toggle>
                                        <br />
                                        <mat-slide-toggle
                                            [formControl]="sammelartikelCtrl"
                                            class="phito-toggle"
                                            color="primary"
                                            (change)="updateEinstellungen()"
                                            [disabled]="isLoadingOrSaving"
                                            [attr.data-cy]="'mmdmd_mat-slide-toggle_24_5_'"
                                        >
                                            Sammelartikel
                                        </mat-slide-toggle>
                                        <br />
                                        <mat-slide-toggle
                                            [formControl]="artikelmengeAusblendenCtrl"
                                            class="phito-toggle"
                                            color="primary"
                                            (change)="updateEinstellungen()"
                                            [disabled]="isLoadingOrSaving"
                                            [attr.data-cy]="'mmdmd_mat-slide-toggle_25_5_'"
                                        >
                                            Artikelmenge in PDFs ausblenden
                                        </mat-slide-toggle>
                                        <br />
                                        <mat-slide-toggle
                                            [formControl]="inAbgangslisteCtrl"
                                            class="phito-toggle"
                                            color="primary"
                                            (change)="updateEinstellungen()"
                                            [disabled]="isLoadingOrSaving"
                                            [attr.data-cy]="'mmdmd_mat-slide-toggle_26_5_'"
                                            >in Ausstallliste auflisten
                                        </mat-slide-toggle>
                                        <br />
                                        <mat-slide-toggle
                                            [formControl]="honorarCtrl"
                                            class="phito-toggle"
                                            color="primary"
                                            (change)="updateEinstellungen()"
                                            [disabled]="isLoadingOrSaving"
                                            [attr.data-cy]="'mmdmd_mat-slide-toggle_27_5_'"
                                        >
                                            Honorar/Gehalt
                                        </mat-slide-toggle>
                                        <br />
                                        <mat-slide-toggle
                                            [formControl]="primanotaIgnorierenCtrl"
                                            class="phito-toggle"
                                            color="primary"
                                            (change)="updateEinstellungen()"
                                            [disabled]="isLoadingOrSaving"
                                            [attr.data-cy]="'mmdmd_mat-slide-toggle_28_5_'"
                                        >
                                            Artikel unter Kosten nicht in Primonata aufnehmen
                                        </mat-slide-toggle>
                                        <br />
                                        <div class="one-row">
                                            <mat-slide-toggle
                                                [formControl]="idexxCtrl"
                                                class="phito-toggle"
                                                color="primary"
                                                (change)="updateEinstellungen()"
                                                [disabled]="isLoadingOrSaving"
                                                [attr.data-cy]="'mmdmd_mat-slide-toggle_29_5_'"
                                            >
                                                Idexx
                                            </mat-slide-toggle>
                                            <mat-form-field
                                                style="margin-left: 12px"
                                                [attr.data-cy]="'mmdmd_mat-form-field_22_8_'"
                                            >
                                                <mat-label [attr.data-cy]="'mmdmd_mat-label_22_9_'"
                                                    >Messgrösse (z.B. OD%, P/Pk %)
                                                </mat-label>
                                                <input
                                                    [formControl]="idexxMessgroesseCtrl"
                                                    matInput
                                                    [disabled]="isLoadingOrSaving"
                                                    (change)="updateEinstellungen()"
                                                    [attr.data-cy]="'mmdmd_input_19_1_'"
                                                />
                                            </mat-form-field>
                                            <mat-form-field
                                                style="margin-left: 12px; min-width: 20vw"
                                                [attr.data-cy]="'mmdmd_mat-form-field_23_8_'"
                                            >
                                                <mat-label [attr.data-cy]="'mmdmd_mat-label_23_9_'"
                                                    >Testbeschreibung
                                                </mat-label>
                                                <textarea
                                                    [formControl]="idexxTestbeschreibungCtrl"
                                                    matInput
                                                    [disabled]="isLoadingOrSaving"
                                                    (change)="updateEinstellungen()"
                                                >
                                                </textarea>
                                            </mat-form-field>
                                            <mat-form-field
                                                style="margin-left: 12px; min-width: 20vw"
                                                [attr.data-cy]="'mmdmd_mat-form-field_24_8_'"
                                            >
                                                <mat-label [attr.data-cy]="'mmdmd_mat-label_24_9_'"
                                                    >Ergebnisbeschreibung
                                                </mat-label>
                                                <textarea
                                                    [formControl]="idexxErgebnisbeschreibungCtrl"
                                                    matInput
                                                    [disabled]="isLoadingOrSaving"
                                                    (change)="updateEinstellungen()"
                                                >
                                                </textarea>
                                            </mat-form-field>
                                        </div>

                                        <br />
                                        <mat-slide-toggle
                                            [formControl]="anwendungsdauerFixCtrl"
                                            class="phito-toggle"
                                            color="primary"
                                            (change)="updateEinstellungen()"
                                            [disabled]="isLoadingOrSaving"
                                            [attr.data-cy]="'mmdmd_mat-slide-toggle_30_5_'"
                                        >
                                            Anwendungsdauer Fix
                                        </mat-slide-toggle>
                                        <br />
                                        <mat-slide-toggle
                                            [formControl]="dosierungFixCtrl"
                                            class="phito-toggle"
                                            color="primary"
                                            (change)="updateEinstellungen()"
                                            [disabled]="isLoadingOrSaving"
                                            [attr.data-cy]="'mmdmd_mat-slide-toggle_31_5_'"
                                        >
                                            Dosierung Fix
                                        </mat-slide-toggle>
                                        <br />
                                        <mat-slide-toggle
                                            [formControl]="massnahmenplanRindCtrl"
                                            class="phito-toggle"
                                            color="primary"
                                            (change)="updateEinstellungen()"
                                            [disabled]="isLoadingOrSaving"
                                            [attr.data-cy]="'mmdmd_mat-slide-toggle_32_5_'"
                                        >
                                            Artikel für Abrechnung Maßnahmenpläne Rind
                                        </mat-slide-toggle>
                                        <br />
                                        <mat-slide-toggle
                                            [formControl]="massnahmenplanRindKurzCtrl"
                                            class="phito-toggle"
                                            color="primary"
                                            (change)="updateEinstellungen()"
                                            [disabled]="isLoadingOrSaving"
                                            [attr.data-cy]="'mmdmd_mat-slide-toggle_33_5_'"
                                        >
                                            Artikel für Abrechnung Maßnahmenpläne Rind kurz
                                        </mat-slide-toggle>
                                        <br />
                                        <mat-slide-toggle
                                            [formControl]="massnahmenplanSchweinCtrl"
                                            class="phito-toggle"
                                            color="primary"
                                            (change)="updateEinstellungen()"
                                            [disabled]="isLoadingOrSaving"
                                            [attr.data-cy]="'mmdmd_mat-slide-toggle_34_5_'"
                                        >
                                            Artikel für Abrechnung Maßnahmenpläne Schwein
                                        </mat-slide-toggle>
                                        <br />
                                        <mat-slide-toggle
                                            [formControl]="tierwohlprotokollRindCtrl"
                                            class="phito-toggle"
                                            color="primary"
                                            (change)="updateEinstellungen()"
                                            [disabled]="isLoadingOrSaving"
                                            [attr.data-cy]="'mmdmd_mat-slide-toggle_35_5_'"
                                        >
                                            Artikel für Abrechnung Tierwohlprotokolle Rind
                                        </mat-slide-toggle>
                                        <br />
                                        <mat-slide-toggle
                                            [formControl]="tierwohlprotokollSchweinCtrl"
                                            class="phito-toggle"
                                            color="primary"
                                            (change)="updateEinstellungen()"
                                            [disabled]="isLoadingOrSaving"
                                            [attr.data-cy]="'mmdmd_mat-slide-toggle_36_5_'"
                                        >
                                            Artikel für Abrechnung Tierwohlprotokolle Schwein
                                        </mat-slide-toggle>
                                        <br />
                                        <mat-slide-toggle
                                            [formControl]="bestandsbesuchsprotokollCtrl"
                                            class="phito-toggle"
                                            color="primary"
                                            (change)="updateEinstellungen()"
                                            [disabled]="isLoadingOrSaving"
                                            [attr.data-cy]="'mmdmd_mat-slide-toggle_37_5_'"
                                        >
                                            Artikel für Abrechnung Bestandsbesuchsprotokolle
                                        </mat-slide-toggle>
                                        <br />
                                        <mat-slide-toggle
                                            [formControl]="neuverschreibungCtrl"
                                            class="phito-toggle"
                                            color="primary"
                                            (change)="updateEinstellungen()"
                                            [disabled]="isLoadingOrSaving"
                                            [attr.data-cy]="'neuverschreibung'"
                                        >
                                            Artikel für Abrechnung Neuverschreibung
                                        </mat-slide-toggle>
                                        <!--
                  <mat-slide-toggle class="phito-toggle" color="primary" [formControl]="qsCtrl" [attr.data-cy]="'mmdmd_mat-slide-toggle_38_5_'">QS Teilnahme
                  </mat-slide-toggle><br>
                  -->
                                    </div>
                                    <div style="width: 650px; align-self: flex-start">
                                        <div style="border: dotted; padding: 12px; margin-top: 24px">
                                            <table>
                                                <thead>
                                                    <th
                                                        style="
                                                            font-size: 0.8em;
                                                            color: gray;
                                                            text-align: left;
                                                            min-width: 250px;
                                                        "
                                                    >
                                                        Eigenschaft
                                                    </th>
                                                    <th style="font-size: 0.8em; color: gray; text-align: left">
                                                        <div class="one-row">
                                                            <div class="one-row">
                                                                ja
                                                                <mat-icon [attr.data-cy]="'mmdmd_mat-icon_16_2_'"
                                                                    >check_box
                                                                </mat-icon>
                                                                <span
                                                                    class="spacer"
                                                                    [attr.data-cy]="'mmdmd_span_25_16_'"
                                                                ></span>
                                                            </div>
                                                            <div class="one-row">
                                                                nein
                                                                <mat-icon [attr.data-cy]="'mmdmd_mat-icon_17_2_'"
                                                                    >check_box_outline_blank
                                                                </mat-icon>
                                                                <span
                                                                    class="spacer"
                                                                    [attr.data-cy]="'mmdmd_span_26_16_'"
                                                                ></span>
                                                            </div>
                                                            <div class="one-row">
                                                                abh&auml;ngig von Behandlung/Abgabe
                                                                <mat-icon [attr.data-cy]="'mmdmd_mat-icon_18_2_'"
                                                                    >warning
                                                                </mat-icon>
                                                                <span
                                                                    class="spacer"
                                                                    [attr.data-cy]="'mmdmd_span_27_16_'"
                                                                ></span>
                                                            </div>
                                                        </div>
                                                    </th>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>Bestandsbuch</td>
                                                        <td>
                                                            <mat-icon [attr.data-cy]="'mmdmd_mat-icon_19_2_'"
                                                                >{{ istBestandsbuch() }}
                                                            </mat-icon>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td> Impfkontrollbuch </td>
                                                        <td>
                                                            <mat-icon [attr.data-cy]="'mmdmd_mat-icon_20_2_'"
                                                                >{{ istImpfkontrollbuch() }}
                                                            </mat-icon>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td> Berechnung Artikelmenge </td>
                                                        <td>
                                                            <mat-icon [attr.data-cy]="'mmdmd_mat-icon_21_2_'"
                                                                >{{ berechneArtikelmenge() }}
                                                            </mat-icon>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td> Berechnung Dosierung </td>
                                                        <td>
                                                            <mat-icon [attr.data-cy]="'mmdmd_mat-icon_22_2_'"
                                                                >{{ berechneDosierung() }}
                                                            </mat-icon>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <span class="spacer" [attr.data-cy]="'mmdmd_span_28_16_'"></span>
                                </div>
                            </mat-card>

                            <mat-card style="margin-bottom: 20px" [attr.data-cy]="'mmdmd_mat-card_6_11_'">
                                <h5>Tierärzteberechnung</h5>
                                <mat-slide-toggle
                                    [formControl]="interneVerrechnungCtrl"
                                    class="phito-toggle"
                                    color="primary"
                                    (change)="updateEinstellungen()"
                                    [attr.data-cy]="'mmdmd_mat-slide-toggle_39_5_'"
                                    >Interne Verrechnung
                                </mat-slide-toggle>
                            </mat-card>
                            </ng-template>
                        </mat-tab>
                        <!--

              Tab VET

            -->
                        <mat-tab *ngIf="hasPermissionForVetTab()" label="VET" [attr.data-cy]="'mmdmd_mat-tab_5_5_'">
                            <ng-template matTabContent>
                            <mat-card
                                style="width: 90%; margin-bottom: 20px; margin-top: 20px"
                                [attr.data-cy]="'mmdmd_mat-card_7_11_'"
                            >
                                <h5>Tierseuchenkasse</h5>
                                <mat-slide-toggle
                                    [formControl]="tskCtrl"
                                    class="phito-toggle"
                                    color="primary"
                                    style="min-width: 100px; width: 32%; margin-right: 1%"
                                    [attr.data-cy]="'mmdmd_mat-slide-toggle_40_5_'"
                                    >Tierseuchenkasse
                                </mat-slide-toggle>
                                <br />
                                <mat-form-field
                                    style="min-width: 350px; width: 33%; margin-right: 1%"
                                    [attr.data-cy]="'mmdmd_mat-form-field_26_8_'"
                                >
                                    <mat-label [attr.data-cy]="'mmdmd_mat-label_25_9_'">TSK Abkürzung</mat-label>
                                    <input
                                        [formControl]="tskAbkuerzungCtrl"
                                        matInput
                                        placeholder="TSK Abkürzung"
                                        type="text"
                                        [attr.data-cy]="'mmdmd_input_21_1_'"
                                    />
                                </mat-form-field>
                                <mat-form-field
                                    style="min-width: 100px; width: 33%"
                                    *kienePermission="[1612]"
                                    [attr.data-cy]="'mmdmd_mat-form-field_27_8_'"
                                >
                                    <mat-label [attr.data-cy]="'mmdmd_mat-label_26_9_'">TSK Preis</mat-label>
                                    <input
                                        [formControl]="tskPreisCtrl"
                                        matInput
                                        placeholder="TSK Preis"
                                        type="number"
                                        [attr.data-cy]="'mmdmd_input_22_1_'"
                                    />
                                </mat-form-field>
                            </mat-card>

                            <mat-card style="width: 90%; margin-bottom: 20px" [attr.data-cy]="'mmdmd_mat-card_8_11_'">
                                <h5>Details</h5>
                                <mat-form-field
                                    style="min-width: 350px; width: 90%"
                                    [attr.data-cy]="'mmdmd_mat-form-field_28_8_'"
                                >
                                    <mat-label [attr.data-cy]="'mmdmd_mat-label_27_9_'">Impftext</mat-label>
                                    <input
                                        [formControl]="impftextCtrl"
                                        matInput
                                        placeholder="Impftext"
                                        type="text"
                                        [attr.data-cy]="'mmdmd_input_23_1_'"
                                    />
                                </mat-form-field>
                                <mat-form-field
                                    style="min-width: 100px; width: 33%; margin-right: 1%"
                                    [attr.data-cy]="'mmdmd_mat-form-field_29_8_'"
                                >
                                    <mat-label [attr.data-cy]="'mmdmd_mat-label_28_9_'"
                                        >BGA / Zulassungsnummer
                                    </mat-label>
                                    <input
                                        [formControl]="bgaCtrl"
                                        matInput
                                        placeholder="BGA"
                                        type="text"
                                        [attr.data-cy]="'mmdmd_input_24_1_'"
                                    />
                                </mat-form-field>
                                <mat-form-field
                                    style="min-width: 100px; width: 33%; margin-right: 1%"
                                    [attr.data-cy]="'mmdmd_mat-form-field_30_8_'"
                                >
                                    <mat-label [attr.data-cy]="'mmdmd_mat-label_29_9_'">Eingangsnummer</mat-label>
                                    <input
                                        [formControl]="eingangsnummerCtrl"
                                        matInput
                                        placeholder="HIT Eingangsnummer"
                                        type="text"
                                        [attr.data-cy]="'mmdmd_input_25_1_'"
                                    />
                                </mat-form-field>
                                <mat-form-field
                                    style="min-width: 100px; width: 33%; margin-right: 1%"
                                    [attr.data-cy]="'mmdmd_mat-form-field_31_8_'"
                                >
                                    <mat-label [attr.data-cy]="'mmdmd_mat-label_30_9_'">Packungs-ID</mat-label>
                                    <input
                                        [formControl]="packungsIdCtrl"
                                        matInput
                                        placeholder="HIT Packungs ID"
                                        type="number"
                                        [attr.data-cy]="'mmdmd_input_26_1_'"
                                    />
                                </mat-form-field>
                                <mat-form-field
                                    style="min-width: 100px; width: 33%; margin-right: 1%"
                                    [attr.data-cy]="'mmdmd_mat-form-field_32_8_'"
                                >
                                    <mat-label [attr.data-cy]="'mmdmd_mat-label_31_9_'">UPD</mat-label>
                                    <input
                                        [formControl]="updCtrl"
                                        matInput
                                        placeholder="HIT UPD"
                                        type="number"
                                        [attr.data-cy]="'mmdmd_input_27_1_'"
                                    />
                                </mat-form-field>
                                <br />
                                <mat-hint
                                    >N&auml;here Informationen sind unter
                                    <a
                                        href="https://www4.hi-tier.de/HitCom/tam_meldungarzn.asp"
                                        target="_blank"
                                        [attr.data-cy]="'mmdmd_a_1_15_'"
                                        >https://www4.hi-tier.de/HitCom/tam_meldungarzn.asp</a
                                    >
                                    zu finden.
                                </mat-hint>
                            </mat-card>

                            <!--
              <mat-card style="width:100%; margin-bottom:20px;" [attr.data-cy]="'mmdmd_mat-card_9_11_'">
                <h5>Impfung</h5>
                <mat-form-field style="min-width: 350px; width: 32%; margin-right: 1%;" [attr.data-cy]="'mmdmd_mat-form-field_33_8_'">
                  <input type="text" matInput [formControl]="impfgebuehr024" placeholder="Impfgebühr 0-24" [attr.data-cy]="'mmdmd_input_28_1_'">
                </mat-form-field>
                <mat-form-field style="min-width: 100px; width: 33%; margin-right: 1%;" [attr.data-cy]="'mmdmd_mat-form-field_34_8_'">
                  <input type="text" matInput [formControl]="impfgebuehr2549" placeholder="Impfgebühr 25-49" [attr.data-cy]="'mmdmd_input_29_1_'">
                </mat-form-field>
                <mat-form-field style="min-width: 100px; width: 33%;" [attr.data-cy]="'mmdmd_mat-form-field_35_8_'">
                  <input type="text" matInput [formControl]="impfgebuehr50" placeholder="Impfgebühr 50+" [attr.data-cy]="'mmdmd_input_30_1_'">
                </mat-form-field>
              </mat-card>
              -->

                            <div style="width: 100%; text-align: right">
                                <button
                                    (click)="updateVet()"
                                    *kienePermission="[1003]"
                                    [disabled]="bezeichnungCtrl.invalid"
                                    color="accent"
                                    mat-flat-button
                                    type="button"
                                    [attr.data-cy]="'mmdmd_button_5_0_'"
                                >
                                    VET Speichern
                                </button>
                            </div>
                            </ng-template>
                        </mat-tab>
                        <!--

              Tab Mischung

            -->
                        <!-- <mat-tab label="Mischung" *ngIf="false" [attr.data-cy]="'mmdmd_mat-tab_6_5_'">
              <form (ngSubmit)="save()" style="width:95%; margin-top: 20px; margin-bottom: 20px;">
                <mat-card style="width:100%; margin-bottom:20px; margin-top:20px;" [attr.data-cy]="'mmdmd_mat-card_10_11_'">
                  <h5>Komponenten</h5>
                  <mat-form-field style="width:10%; margin-right:1%;" [attr.data-cy]="'mmdmd_mat-form-field_36_8_'">
                    <input type="number" matInput placeholder="Menge" [formControl]="mischung1AmountCtrl" [attr.data-cy]="'mmdmd_input_31_1_'">
                  </mat-form-field>
                  <mat-form-field style="width:30%; margin-right:1%;" [attr.data-cy]="'mmdmd_mat-form-field_37_8_'">
                    <input type="text" matInput placeholder="Artikel" [formControl]="mischung1AmountCtrl" [attr.data-cy]="'mmdmd_input_32_1_'">
                  </mat-form-field>
                  <mat-form-field style="width:30%; margin-right:1%;" [attr.data-cy]="'mmdmd_mat-form-field_38_8_'">
                    <input type="text" matInput placeholder="Dosierung" [formControl]="mischung1AmountCtrl" [attr.data-cy]="'mmdmd_input_33_1_'">
                  </mat-form-field>
                  <mat-form-field style="width:20%; margin-right:1%;" [attr.data-cy]="'mmdmd_mat-form-field_39_8_'">
                    <input type="text" matInput placeholder="Charge" [formControl]="mischung1AmountCtrl" [attr.data-cy]="'mmdmd_input_34_1_'">
                  </mat-form-field>
                  <mat-form-field style="width:10%; margin-right:1%;" [attr.data-cy]="'mmdmd_mat-form-field_40_8_'">
                    <input type="number" matInput placeholder="Menge" [formControl]="mischung1AmountCtrl" [attr.data-cy]="'mmdmd_input_35_1_'">
                  </mat-form-field>
                  <mat-form-field style="width:30%; margin-right:1%;" [attr.data-cy]="'mmdmd_mat-form-field_41_8_'">
                    <input type="text" matInput placeholder="Artikel" [formControl]="mischung1AmountCtrl" [attr.data-cy]="'mmdmd_input_36_1_'">
                  </mat-form-field>
                  <mat-form-field style="width:30%; margin-right:1%;" [attr.data-cy]="'mmdmd_mat-form-field_42_8_'">
                    <input type="text" matInput placeholder="Dosierung" [formControl]="mischung1AmountCtrl" [attr.data-cy]="'mmdmd_input_37_1_'">
                  </mat-form-field>
                  <mat-form-field style="width:20%; margin-right:1%;" [attr.data-cy]="'mmdmd_mat-form-field_43_8_'">
                    <input type="text" matInput placeholder="Charge" [formControl]="mischung1AmountCtrl" [attr.data-cy]="'mmdmd_input_38_1_'">
                  </mat-form-field>
                  <mat-form-field style="width:10%; margin-right:1%;" [attr.data-cy]="'mmdmd_mat-form-field_44_8_'">
                    <input type="number" matInput placeholder="Menge" [formControl]="mischung1AmountCtrl" [attr.data-cy]="'mmdmd_input_39_1_'">
                  </mat-form-field>
                  <mat-form-field style="width:30%; margin-right:1%;" [attr.data-cy]="'mmdmd_mat-form-field_45_8_'">
                    <input type="text" matInput placeholder="Artikel" [formControl]="mischung1AmountCtrl" [attr.data-cy]="'mmdmd_input_40_1_'">
                  </mat-form-field>
                  <mat-form-field style="width:30%; margin-right:1%;" [attr.data-cy]="'mmdmd_mat-form-field_46_8_'">
                    <input type="text" matInput placeholder="Dosierung" [formControl]="mischung1AmountCtrl" [attr.data-cy]="'mmdmd_input_41_1_'">
                  </mat-form-field>
                  <mat-form-field style="width:20%; margin-right:1%;" [attr.data-cy]="'mmdmd_mat-form-field_47_8_'">
                    <input type="text" matInput placeholder="Charge" [formControl]="mischung1AmountCtrl" [attr.data-cy]="'mmdmd_input_42_1_'">
                  </mat-form-field>
                  <mat-form-field style="width:10%; margin-right:1%;" [attr.data-cy]="'mmdmd_mat-form-field_48_8_'">
                    <input type="number" matInput placeholder="Menge" [formControl]="mischung1AmountCtrl" [attr.data-cy]="'mmdmd_input_43_1_'">
                  </mat-form-field>
                  <mat-form-field style="width:30%; margin-right:1%;" [attr.data-cy]="'mmdmd_mat-form-field_49_8_'">
                    <input type="text" matInput placeholder="Artikel" [formControl]="mischung1AmountCtrl" [attr.data-cy]="'mmdmd_input_44_1_'">
                  </mat-form-field>
                  <mat-form-field style="width:30%; margin-right:1%;" [attr.data-cy]="'mmdmd_mat-form-field_50_8_'">
                    <input type="text" matInput placeholder="Dosierung" [formControl]="mischung1AmountCtrl" [attr.data-cy]="'mmdmd_input_45_1_'">
                  </mat-form-field>
                  <mat-form-field style="width:20%; margin-right:1%;" [attr.data-cy]="'mmdmd_mat-form-field_51_8_'">
                    <input type="text" matInput placeholder="Charge" [formControl]="mischung1AmountCtrl" [attr.data-cy]="'mmdmd_input_46_1_'">
                  </mat-form-field>
                </mat-card>
              </form>
            </mat-tab> -->
                        <!--

              Tab Medikation

            -->
                        <mat-tab
                            *ngIf="hasPermissionForMedikationTab()"
                            label="Medikation"
                            [attr.data-cy]="'mmdmd_mat-tab_7_5_'"
                        >
                            <ng-template matTabContent>
                            <kiene-artikel-indikation
                                [mandanten]="availableMandanten"
                                [material]="material"
                                [attr.data-cy]="'mmdmd_mat-tab_7_5_1'"
                            >
                            </kiene-artikel-indikation>
                            <kiene-artikel-tierart
                                [mandanten]="availableMandanten"
                                [material]="material"
                                [attr.data-cy]="'mmdmd_mat-tab_7_5_2'"
                            >
                            </kiene-artikel-tierart>
                            <kiene-artikel-anwendung
                                [mandanten]="availableMandanten"
                                [material]="material"
                                [attr.data-cy]="'mmdmd_mat-tab_7_5_3'"
                            >
                            </kiene-artikel-anwendung>

                            <kiene-material-wartezeit
                                [material]="material"
                                [attr.data-cy]="'mmdmd_mat-tab_7_5_4'"
                            ></kiene-material-wartezeit>
                            </ng-template>
                        </mat-tab>

                        <!--

              Tab Untersuchung

            -->
                        <mat-tab
                            *ngIf="hasPermissionForUntersuchungTab()"
                            label="Untersuchung"
                            [attr.data-cy]="'mmdmd_mat-tab_8_5_'"
                        >
                            <ng-template matTabContent>
                            <div style="width: 95%">
                                <mat-card
                                    style="width: 100%; margin-top: 20px"
                                    [attr.data-cy]="'mmdmd_mat-card_11_11_'"
                                >
                                    <h4>Labor</h4>
                                    <kiene-autocomplete
                                        *ngIf="hasPermission(1071)"
                                        (elementSelected)="setLabor($event)"
                                        [apiUrl]="'lieferant/'"
                                        [displayField]="'bezeichnung'"
                                        [kieneObject]="labor"
                                        [placeholder]="'Labor'"
                                        [readPermission]="[1071]"
                                        [attr.data-cy]="'mmdmd_kiene-autocomplete_1_11_1_'"
                                    ></kiene-autocomplete>
                                    <mat-form-field *ngIf="!hasPermission(1071)" style="width: 100%">
                                        <mat-label>Labor</mat-label>
                                        <input matInput [value]="material?.lieferant_labor || ''" readonly disabled />
                                    </mat-form-field>
                                </mat-card>
                                <mat-card
                                    style="width: 100%; margin-top: 20px"
                                    [attr.data-cy]="'mmdmd_mat-card_12_11_'"
                                >
                                    <h4>Untersuchungsgruppe</h4>
                                    <kiene-autocomplete
                                        *ngIf="hasPermission(1441)"
                                        (elementSelected)="setUntersuchungsgruppe($event)"
                                        [apiUrl]="'untersuchungsgruppe/'"
                                        [displayField]="'bezeichnung'"
                                        [kieneObject]="untersuchungsgruppe"
                                        [placeholder]="'Untersuchungsgruppe'"
                                        [readPermission]="[1441]"
                                        [attr.data-cy]="'mmdmd_kiene-autocomplete_2_11_'"
                                    ></kiene-autocomplete>
                                    <mat-form-field *ngIf="!hasPermission(1441)" style="width: 100%">
                                        <mat-label>Untersuchungsgruppe</mat-label>
                                        <input matInput [value]="material?.untersuchungsgruppe || ''" readonly disabled />
                                    </mat-form-field>
                                </mat-card>
                                <mat-card
                                    style="width: 100%; margin-top: 20px"
                                    [attr.data-cy]="'mmdmd_mat-card_13_11_'"
                                >
                                    <h4>Anzahl Untersuchungen</h4>
                                    <mat-form-field style="width: 100%" [attr.data-cy]="'mmdmd_mat-form-field_52_8_'">
                                        <input
                                            [formControl]="anzahlUntersuchungenCtrl"
                                            matInput
                                            placeholder="Anzahl Untersuchungen"
                                            type="number"
                                            [attr.data-cy]="'mmdmd_input_47_1_'"
                                        />
                                    </mat-form-field>
                                </mat-card>
                                <div style="width: 100%; text-align: right; margin-top: 20px">
                                    <button
                                        (click)="updateUntersuchung()"
                                        *kienePermission="[1007]"
                                        [disabled]="bezeichnungCtrl.invalid"
                                        color="accent"
                                        mat-flat-button
                                        [attr.data-cy]="'mmdmd_button_6_0_'"
                                    >
                                        Untersuchung Speichern
                                    </button>
                                </div>
                            </div>
                            </ng-template>
                        </mat-tab>

                        <mat-tab
                            *ngIf="KieneUtils.isApiOne(material.stueckliste) && hasPermissionForStueckliste()"
                            label="Stückliste"
                            [attr.data-cy]="'mmdmd_mat-tab_9_5_'"
                        >
                            <ng-template matTabContent>
                                <kiene-stueckliste (reload)="loadArtikelAdmin()" [material]="material">
                                </kiene-stueckliste>
                            </ng-template>
                        </mat-tab>
                    </mat-tab-group>
                </div>
            </div>
        </div>
    </div>
</div>
